import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SystemSelectService {

  constructor() { }

  public system = new Subject<any>();
  private program = new Subject<any>();
  public programState: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public zoneState: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public systemState: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);


  data: any;
  programData: any;

  // Observable string streams
  system$ = this.system.asObservable();
  program$ = this.program.asObservable();

  get() {
    return this.system.next(this.data);
  }

  getProgram() {
    return this.program.next(this.programData);
  }

  add(obj: any) {
    this.data = obj;
    this.system.next(obj);
  }
}
